import React, { forwardRef } from 'react';
interface DatePickerProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
}
export const DatePicker = forwardRef<HTMLInputElement, DatePickerProps>(({
  label,
  error,
  className = '',
  id,
  ...props
}, ref) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-310">
        {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-311">
            {label}
          </label>}
        <input ref={ref} type="date" id={inputId} className={`
            w-full px-3 py-2 border rounded-lg text-gray-900
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
            disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed
            ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'}
            ${className}
          `} aria-invalid={error ? 'true' : 'false'} aria-describedby={error ? `${inputId}-error` : undefined} {...props} data-id="element-312" />
        {error && <p id={`${inputId}-error`} className="mt-1 text-sm text-red-600" data-id="element-313">
            {error}
          </p>}
      </div>;
});
DatePicker.displayName = 'DatePicker';